import React from 'react';
import ReactDOM from 'react-dom/client';
// import ReactDOM from "react-dom";
import App from './App';
// import './styles.css';
// import "./styles.scss";
// import TaxCertUploader from './components/TaxCertUploaderNoText';
import TaxCertUploader from './components/TaxCertUploader';

// ReactDOM.createRoot(document.getElementById('quote_portal')).render(
// ReactDOM.createRoot(document.getElementById('root')).render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// import * as Sentry from "@sentry/react";
// Sentry.init({
//   dsn: "https://a01032b20a76b5cd242b0eb7f368a617@o4511469266993152.ingest.us.sentry.io/4511469268172800",
//   // Setting this option to true will send default PII data to Sentry.
//   // For example, automatic IP address collection on events
//   sendDefaultPii: true,
//   integrations: [
//     // send console.log, console.warn, and console.error calls as logs to Sentry
//     Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
//   ],
//   // Enable logs to be sent to Sentry
//   enableLogs: true,
// });
// Sentry.setTag("location", "quote_portal");

function initQuotePortal() {
  const container = document.getElementById('quote_portal') || document.getElementById('root');

  if (container) {
    // console.log('Quote Portal: Mounting React app...');
    const root = ReactDOM.createRoot(container);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } else {
    console.error('Quote Portal: Container element not found!');
  }
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuotePortal);
} else {
  initQuotePortal();
}



const taxCertContainer = document.getElementById('upload_tax_cert');

if (taxCertContainer) {
  ReactDOM.createRoot(taxCertContainer).render(
    <React.StrictMode>
      <TaxCertUploader 
        showCard={true}
        showTitle={true}
        showDescription={false}
        title="Upload Tax Exemption"
        message="Upload your tax exemption certificate here."
      />
    </React.StrictMode>
  );
}
